export default function CabPrice({cabName, cabPrice}) {
    return(
        <>
            <p className="my-1">{cabName} - <span className="text-red-500">from {cabPrice} per week.</span></p> 
        </>
    )
}